export class Adb2cBody {
  constructor(
    public readonly accountEnabled: boolean,
    public readonly givenName: string,
    public readonly surname: string,
    public readonly displayName: string,
    public readonly mailNickname: string,
    public readonly creationType: string,
    public readonly mobilePhone: string,
    public readonly identities: Identity[],
    public readonly passwordProfile: PasswordProfile,
    public readonly mail: string
  ) {
  }
}

export class Identity {
  constructor(
    public readonly signInType: string,
    public readonly issuer: string,
    public readonly issuerAssignedId: string,
  ) {
  }
}

export class PasswordProfile {
  constructor(
    public readonly password: string
  ) {
  }
}
